export default "__VITE_ASSET__D$RbFJ4U__"